module.exports = __webpack_public_path__ + "assets/img/teacher (9).c400df42.png";